import { HardRefresh } from "source/shared/routingUtils"

export function Giving() {
  return <HardRefresh />
}
